import { createContext } from "react"

export interface FormMoughataaInterface {
  name: string, setName: (name: string) => void,
}

export const DefaultFormMoughataaInterface: FormMoughataaInterface = {
  name: "", setName: () => {},
}

export const FormMoughataaContext = createContext<FormMoughataaInterface>(DefaultFormMoughataaInterface)

export interface moughataaInterface {
  _id: any,
  name: string,
}

export const DefaultMoughataaInterface: moughataaInterface =  {
  _id: null,
  name: "",
}

export interface ShowMoughataaInterface {
  showSuccessMsg: boolean, setShowSuccessMsg: (showSuccessMsg: boolean) => void,
  showAddModal: boolean, setShowAddModal: (showAddModal: boolean) => void,
  showEditModal: boolean, setShowEditModal: (showEditModal: boolean) => void,
  showDeleteModal: boolean, setShowDeleteModal: (showDeleteModal: boolean) => void,
  selectedMoughataa: moughataaInterface, setSelectedMoughataa: (selectedMoughataa: moughataaInterface) => void,
}

export const DefaultShowMoughataaInterface:ShowMoughataaInterface = {
  showSuccessMsg: false, setShowSuccessMsg:() => {},
  showAddModal: false, setShowAddModal: () => {},
  showEditModal: false, setShowEditModal: () => {},
  showDeleteModal: false, setShowDeleteModal: () => {},
  selectedMoughataa: DefaultMoughataaInterface, setSelectedMoughataa: () => {},
}

export const ShowMoughataaContext = createContext<ShowMoughataaInterface>(DefaultShowMoughataaInterface)
